import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "row actions",
  style: {"padding":"1rem .5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ozn_button = _resolveComponent("ozn-button")!

  return (_openBlock(), _createBlock($setup["EditableBlock"], {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:supplier', $props.supplier?.sys?.id, $event))),
    title: "Api settings",
    layout: "grid",
    "model-value": $props.supplier,
    "column-count": 2
  }, {
    default: _withCtx(({ editState }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (editState.token?.access_token && $setup.showToken)
            ? (_openBlock(), _createBlock($setup["Clipable"], {
                key: 0,
                class: "token",
                payload: editState.token?.access_token,
                message: "Token copied to clipboard"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(editState.token?.access_token), 1)
                ]),
                _: 2
              }, 1032, ["payload"]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_ozn_button, {
            class: "minimal",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showToken = true))
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Show Api token")
            ])),
            _: 2
          }, 1536), [
            [_vShow, editState.token?.access_token && !$setup.showToken]
          ])
        ]),
        (editState.token?.access_token)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives(_createVNode(_component_ozn_button, {
                class: "minimal",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showToken = false))
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Hide Api token")
                ])),
                _: 1
              }, 512), [
                [_vShow, $setup.showToken]
              ]),
              _withDirectives(_createVNode(_component_ozn_button, {
                class: "error minimal",
                onClick: ($event: any) => ($setup.deleteToken(editState.sys.id))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Delete Api token")
                ])),
                _: 2
              }, 1032, ["onClick"]), [
                [_vShow, $setup.showToken]
              ])
            ]))
          : (_openBlock(), _createBlock(_component_ozn_button, {
              key: 1,
              onClick: ($event: any) => ($setup.generateToken(editState.sys.id))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Generate Api Token")
              ])),
              _: 2
            }, 1032, ["onClick"]))
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}